import React from 'react';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import {
  CS_QNA_LIST_FILTER_OPTION_MODEL,
  CS_QNA_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/cs/qna/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { CS_QNA_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/csQnaConstants';
import columns from './columns';

const CsQnaList = (props) => {
  const { csQnaList, getList, getExcelDownload } = props;
  const { list, filterOption, sortOption, pagination, summary } = csQnaList;

  return (
    <div className="cs-qna-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: CS_QNA_LIST_FILTER_OPTION_MODEL,
          sortOption: CS_QNA_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={CS_QNA_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            ...utils,
          })
        }
      />
    </div>
  );
};

export default CsQnaList;
